import { IApplicationState } from '../../types/redux';

export function getNewbuildingBlackFridayActive(state: IApplicationState) {
  return state.config.newbuildingBlackFriday.isActive;
}
